export const FLEXI_LOAN_PRODUCT_TYPE = 'credit_facility';
export const IWOCAPAY_PRODUCT_TYPE = 'iwocapay';
export const MERCHANT_CASH_ADVANCE_PRODUCT_TYPE = 'merchant_cash_advance';
